// extracted by mini-css-extract-plugin
export var card = "_si-0";